import { Button } from "components/ButtonNew";
import { ComponentsCommonHeaderBasic } from "components/ComponentsCommonHeader";
import { useTranslation } from "react-i18next";

type TechnicalConfigTabHeaderProps = {
  descriptionKey: string;
  manageCatalogKey: string;
  onManageCatalog: () => void;
  titleKey: string;
};

export const TechnicalConfigTabHeader = ({
  descriptionKey,
  manageCatalogKey,
  onManageCatalog,
  titleKey,
}: TechnicalConfigTabHeaderProps) => {
  const { t } = useTranslation();

  return (
    <ComponentsCommonHeaderBasic
      actionComponent={
        <Button onClick={onManageCatalog} size="sm" startIconName="Settings" variant="secondary">
          {t(manageCatalogKey)}
        </Button>
      }
      description={t(descriptionKey)}
      title={t(titleKey)}
    />
  );
};
